import * as tslib_1 from "tslib";
import { BackDocumentScanImage } from 'src/app/pages/identification/back-document-scan/back-document-scan-image';
import { BUSINESS_CONST } from '../../constants/business.constants';
import { EVENT } from '../../constants/dali.constants';
import { DocumentModel } from '../../models/document.model';
import { LogDeviceModel } from '../../models/log-device.model';
import { AbreCuentasService } from '../abre-cuentas/abre-cuentas.service';
import { BitacoraService } from '../bitacora/bitacora.service';
import { ChannelCommunicatorService } from '../communicator/channel-communicator/channel-communicator.service';
import { PortalPnImplService } from '../communicator/channel-communicator/implementation/portalpn-impl.service';
import { BioCatchService } from '../external/biocatch/biocatch.service';
import { HelpersService } from '../helpers/helpers-onboarding.service';
import { LoaderService } from '../loader/loader.service';
import { NavigationService } from '../navigation/navigation-onboarding.service';
import { RequestService } from '../request/request-onboarding.service';
import { TaggingService } from '../tagging/tagging.service';
import { CryptoVaultService } from '../external/crypto-vault/crypto-vault.service';
import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../helpers/helpers-onboarding.service";
import * as i2 from "../request/request-onboarding.service";
import * as i3 from "../external/biocatch/biocatch.service";
import * as i4 from "../navigation/navigation-onboarding.service";
import * as i5 from "../abre-cuentas/abre-cuentas.service";
import * as i6 from "../communicator/channel-communicator/implementation/portalpn-impl.service";
import * as i7 from "../communicator/channel-communicator/channel-communicator.service";
import * as i8 from "../tagging/tagging.service";
import * as i9 from "../bitacora/bitacora.service";
import * as i10 from "../external/crypto-vault/crypto-vault.service";
import * as i11 from "../loader/loader.service";
/**
 * Definición para que la clase sea vista desde root
 *
 * *Class definition to be seen from root*
 *
 * @type {Injectable}
 */
var IdentificationService = /** @class */ (function () {
    /**
     * Constructor de la clase
     *
     * *Class Contstructor.*
     *
     * Inicializa los métodos para los modelos
     *
     * *Initialize method for models*
     *
     * @param {HelpersService}             helpersService
     * @param {RequestService}             requestService
     * @param {BioCatchService}            bioCatchService
     * @param {NavigationService}          navigationService
     * @param {AbreCuentasService}         abreCuentasService
     * @param {PortalPnImplService}        apppnImplService
     * @param {ChannelCommunicatorService} channelCommunicatorService
     *
     */
    function IdentificationService(helpersService, requestService, bioCatchService, navigationService, abreCuentasService, apppnImplService, channelCommunicatorService, taggingService, bitacoraService, cipherService, loaderService) {
        this.helpersService = helpersService;
        this.requestService = requestService;
        this.bioCatchService = bioCatchService;
        this.navigationService = navigationService;
        this.abreCuentasService = abreCuentasService;
        this.apppnImplService = apppnImplService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.taggingService = taggingService;
        this.bitacoraService = bitacoraService;
        this.cipherService = cipherService;
        this.loaderService = loaderService;
        this.statusSendBackDocument$ = new Subject();
    }
    /**
     * Validación de aceptación de términos y condiciones, registro en la bítacora
     *
     * *Terms and conditions acceptance validation*
     */
    IdentificationService.prototype.termsAndConditions = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var devicePrint, ipBiocatch;
            return tslib_1.__generator(this, function (_a) {
                devicePrint = new LogDeviceModel();
                try {
                    ipBiocatch = this.bioCatchService.getCurrentScoreIp();
                    devicePrint.device = this.abreCuentasService.getDeviceInfo();
                    if (devicePrint !== undefined && devicePrint !== null) {
                        devicePrint.device.ip = ipBiocatch;
                        devicePrint.terms_type = 'term_condition_accept';
                        devicePrint.device.event_name = 'term_condicion_acept';
                        this.abreCuentasService.setdeviceInfo(devicePrint);
                        return [2 /*return*/, this.requestService.saveDataInBitacora(devicePrint)];
                    }
                }
                catch (error) {
                    console.log(error);
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Envía la información de la parte de atrás del documento
     *
     * *Sends back document info*
     *
     * @type {function}
     * @returns {Promise}
     */
    IdentificationService.prototype.sendBackDocumentInfo = function (documentInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var product_type;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                product_type = this.abreCuentasService.getproductSelected().product_type;
                this.requestService.sendBackDocumentInfo(documentInfo).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var codigo, invalidDocument, dataResponse, bitacoraEvent;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(!response || !response.status || response.status === 500)) return [3 /*break*/, 1];
                                this.generatedError('500');
                                return [3 /*break*/, 4];
                            case 1:
                                if (!(response.status !== 200)) return [3 /*break*/, 2];
                                codigo = response.error.codigo;
                                invalidDocument = 'Documento Invalido';
                                switch (codigo) {
                                    case '422-01':
                                        this.generatedError('107');
                                        this.navigationService.pageLoadTag('No fue posible continuar la solicitud', ['pv10', 'pv111', 'pv71', '']);
                                        return [2 /*return*/];
                                    case '422-02':
                                    case '422-03':
                                        this.navigationService.pageLoadTag(invalidDocument, ['pv11', 'pv118', 'pv78', '']);
                                        this.generatedResponse('104');
                                        break;
                                    case '422-04':
                                    case '422-05':
                                        this.navigationService.pageLoadTag(invalidDocument, ['pv11', 'pv118', 'pv78', '']);
                                        this.generatedResponse('103');
                                        break;
                                    case '422-06':
                                        this.generatedError('106');
                                        return [2 /*return*/];
                                    default:
                                        this.generatedError('500');
                                        return [2 /*return*/];
                                }
                                return [3 /*break*/, 4];
                            case 2: return [4 /*yield*/, JSON.parse(this.cipherService.decrypt(response.body.data.message))];
                            case 3:
                                dataResponse = _a.sent();
                                console.log(dataResponse, 'responsedatad');
                                this.abreCuentasService.setProspectResponse(dataResponse);
                                this.validateDataClient(dataResponse, documentInfo);
                                if (dataResponse.client && !this.abreCuentasService.getPostlogin()) {
                                    this.generatedError('108');
                                    bitacoraEvent = "CN_is_Client";
                                    this.bitacoraService.saveDataInBitacora(bitacoraEvent);
                                    this.bitacoraService.saveDataInBitacora('Cliente_en_listas_SI');
                                    return [2 /*return*/];
                                }
                                if (!this.abreCuentasService.getPostlogin()) {
                                    if (this.validateProcessForOldClients()) {
                                        this.generatedResponse('200');
                                    }
                                }
                                if (dataResponse.list_query_status.status_code === '5') {
                                    this.bitacoraService.saveDataInBitacora('Cliente_en_listas_SI');
                                    this.generatedError('107');
                                }
                                _a.label = 4;
                            case 4: return [2 /*return*/];
                        }
                    });
                }); }).catch(function () {
                    _this.generatedError('500');
                });
                return [2 /*return*/];
            });
        });
    };
    IdentificationService.prototype.generatedError = function (errorCode) {
        this.statusSendBackDocument$.next({
            code: errorCode,
            error: true,
        });
    };
    IdentificationService.prototype.generatedResponse = function (responseCode) {
        this.statusSendBackDocument$.next({
            code: responseCode,
            error: false,
        });
    };
    IdentificationService.prototype.validateDataClient = function (data, documentInfo) {
        documentInfo.date_of_issue = data.expedition_date;
        documentInfo.issued_city = data.expedition_municipality;
        documentInfo.issued_department = data.dispatch_department;
        if (data.document.birthdate) {
            documentInfo.birthdate = data.document.birthdate;
        }
        if (data.document.first_name) {
            documentInfo.firstname = data.first_name;
        }
        if (data.document.second_lastname) {
            documentInfo.middlename = data.second_name;
        }
        this.abreCuentasService.setDocumentInfo(documentInfo);
        console.warn('Información actualizada: ', this.abreCuentasService.getDocumentInfo());
    };
    /**
     * Valida el product type y retorna el valor del successCode
     */
    IdentificationService.prototype.getSuccessCodeByValidateProductType = function (product_type) {
        if (product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
            product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE) {
            this.navigationService.pageLoadTag(false, ['pv9', 'pv00', 'pv00', 'pv262']);
            return '105';
        }
        return '108';
    };
    /**
     * Valida el proceso para clientes antiguos
     *
     * *Process validation for old clients*
     *
     * @type {function}
     * @param {ExternalResponse} scanResponse
     */
    IdentificationService.prototype.validateProcessForOldClients = function () {
        var _this = this;
        var configsMap = this.abreCuentasService.getAbreCuentasConfigs();
        if (!configsMap.old_clients_enabled_for) {
            return true;
        }
        if (!this.abreCuentasService.getAppInfo().infoUnavailable) {
            var rules = [{
                    rule_name: configsMap.old_clients_enabled_for,
                    parameters: {
                        channel_id: this.abreCuentasService.getAppInfo().channelId,
                        mobile_platform: this.abreCuentasService.getAppInfo().platform,
                        app_version: this.abreCuentasService.getAppInfo().appVersion,
                    },
                }];
            this.requestService.validateRules(rules).then(function (rulesResponse) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(rulesResponse && rulesResponse.statusCode === 200)) return [3 /*break*/, 2];
                            return [4 /*yield*/, rulesResponse.data.rules_result.forEach(function (rule) {
                                    if (configsMap.old_clients_enabled_for !== rule.rule_name) {
                                        return true;
                                    }
                                    if (!rule.result) {
                                        _this.generatedResponse('105');
                                        return false;
                                    }
                                    return true;
                                })];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            this.generatedError('500');
                            return [2 /*return*/, false];
                        case 3: return [2 /*return*/];
                    }
                });
            }); });
        }
    };
    /**
     * Escanea la parte de atrás del documento
     *
     * *Sends back document info*
     *
     * @type {function}
     * @returns {Promise}
     */
    IdentificationService.prototype.backDocumentScan = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var versionNumber, oldVersionNumber, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (!(this.abreCuentasService.getAbreCuentasConfigs().old_version_apppn &&
                            this.channelCommunicatorService.getChannelId() === this.apppnImplService.CHANNEL_ID)) return [3 /*break*/, 2];
                        versionNumber = this.helpersService.versionToNumber(this.abreCuentasService.getAppInfo().appVersion);
                        oldVersionNumber = this.helpersService.versionToNumber(this.abreCuentasService.getAbreCuentasConfigs().old_version_apppn);
                        if (!(versionNumber <= oldVersionNumber)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.callBackDocumentScanOldVersions()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, this.callBackDocumentScanNewVersions()];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        err_1 = _a.sent();
                        console.log(err_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Acción de respuesta del servicio de escaneo de la parte de atrás del documento en antiguas versiones
     *
     * *Response action of Back-document scanning service of old versions*
     *
     * @type {function}
     */
    IdentificationService.prototype.callBackDocumentScanOldVersions = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.abreCuentasService.setDevicePermissions('camera');
                return [2 /*return*/, new Promise(function (resolve, reject) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.channelCommunicatorService.getImpl().backDocumentScan(this.abreCuentasService.getBytteConfig().licenses[this.channelCommunicatorService.getChannelId()].androidOld, this.abreCuentasService.getBytteConfig().licenses[this.channelCommunicatorService.getChannelId()].iosOld, '', this.abreCuentasService.getBytteConfig().timeouts.backDocumentScan.seconds)
                                        .then(function (response) { return resolve(response); })
                                        .catch(function (err) { return reject(err); })];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    /**
     * Acción de respuesta del servicio de escaneo de la parte de atrás del documento en nuevas versiones
     *
     * *Response action of Back-document scanning service of new versions*
     *
     * @type {function}
     * @param {ExternalResponse} scanResponse
     */
    IdentificationService.prototype.callBackDocumentScanNewVersions = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        var _this = this;
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.channelCommunicatorService.getImpl().verifyAndRequestPermissions().then(function (responsePermission) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                        return tslib_1.__generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    if (!(responsePermission.code && responsePermission.code === '200')) return [3 /*break*/, 2];
                                                    this.abreCuentasService.setDevicePermissions('camera');
                                                    return [4 /*yield*/, this.channelCommunicatorService.getImpl().backDocumentScan(this.abreCuentasService.getBytteConfig().licenses[this.channelCommunicatorService.getChannelId()].android, this.abreCuentasService.getBytteConfig().licenses[this.channelCommunicatorService.getChannelId()].ios, this.abreCuentasService.getTransactionId(), this.abreCuentasService.getBytteConfig().timeouts.backDocumentScan.seconds)
                                                            .then(function (response) { return resolve(response); })
                                                            .catch(function (err) { return reject(err); })];
                                                case 1:
                                                    _a.sent();
                                                    return [3 /*break*/, 3];
                                                case 2:
                                                    this.navigationService.pageLoadTag('Necesitamos permisos para usar tu cámara', ['pv220', 'pv117', 'pv77']);
                                                    this.navigationService.navigateToGeneralInformation('401');
                                                    reject('Necesitamos permisos para usar tu cámara');
                                                    _a.label = 3;
                                                case 3: return [2 /*return*/];
                                            }
                                        });
                                    }); }).catch(function (errPermission) { return reject(errPermission); })];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    /**
     * Acción de respuesta del servicio de escaneo de la parte de atrás del documento
     *
     * *Back document scan service response action*
     *
     * @type {function}
     * @param {ExternalResponse} scanResponse
     */
    IdentificationService.prototype.callbackBackDocumentScan = function (scanResponse) {
        var _this = this;
        var bitacoraEvent = "backdocumentScan_success";
        this.bitacoraService.saveDataInBitacora(bitacoraEvent);
        this.navigationService.pageLoadTag(false, ['pv6', 'pv102', 'pv61', '']);
        var tagPageName = this.taggingService.getTagIdByProduct();
        if (!scanResponse.code) {
            this.navigationService.navigateToGeneralInformation('500');
            return;
        }
        switch (scanResponse.code) {
            case '400': // Wrong license activation key
            case '403': // Origin not authorized
            case '404': // Operation not found
            case '500': // Internal error
                // this.loaderService.hide();
                this.navigationService.navigateToGeneralInformation('500');
                return;
            case '504': // Failed attempt
                this.abreCuentasService.getAbreCuentasModel().backDocumentScanAttempts++;
                if (this.abreCuentasService.getAbreCuentasModel().backDocumentScanAttempts >=
                    this.abreCuentasService.getBytteConfig().failedAttempts.backDocumentScan) {
                    this.navigationService.pageLoadTag('No fue posible validad tu identidad', ['pv8', 'pv117', 'pv77', '']);
                    this.abreCuentasService.caseInfoError('102');
                    this.navigationService.nextStep('102');
                }
                else {
                    var errorImage = {
                        renderer: 'svg',
                        loop: true,
                        autoplay: true,
                        animationData: BackDocumentScanImage,
                    };
                    this.abreCuentasService.setImageLottieError(errorImage);
                    this.navigationService.pageLoadTag('No fue posible obtener la foto', ['pv7', 'pv110', 'pv70']);
                    this.abreCuentasService.caseInfoError('111');
                    this.navigationService.nextStep('111');
                }
                // this.loaderService.hide();
                return;
        }
        try {
            var changes = [
                {
                    path: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionName"].path,
                    value: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionName"].value,
                },
                {
                    path: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionDetailsProductcategory"].path,
                    value: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionDetailsProductcategory"].value,
                },
            ];
            var event_1 = {
                category: {
                    module: EVENT.customCategory.module.body,
                    type: EVENT.customCategory.type.image,
                    position: EVENT.customCategory.position.center,
                },
                action: EVENT.customAction.show,
                label: EVENT[tagPageName + "E1customLabel"],
            };
            this.taggingService.pageTagEvent(event_1, changes);
        }
        catch (error) {
            // this.loaderService.hide();
            console.log(error);
        }
        console.warn('Back-Document: ', scanResponse);
        var documentInfo = new DocumentModel();
        var document_type = '';
        document_type = this.getDocumentType(scanResponse.data.document_type);
        documentInfo.document_type = document_type;
        documentInfo.card_number = scanResponse.data.card_number;
        documentInfo.document_number = parseInt(scanResponse.data.document_number, 10).toString();
        documentInfo.primary_lastname = this.abreCuentasService.converttoPascalCase(scanResponse.data.primary_lastname);
        documentInfo.second_lastname = this.abreCuentasService.converttoPascalCase(scanResponse.data.second_lastname);
        documentInfo.firstname = this.abreCuentasService.converttoPascalCase(scanResponse.data.firstname);
        documentInfo.middlename = this.abreCuentasService.converttoPascalCase(scanResponse.data.midlename);
        documentInfo.sex = this.getSexToString(scanResponse.data.sex);
        documentInfo.birthdate = scanResponse.data.birthdate;
        documentInfo.date_of_issue = scanResponse.data.date_of_issue;
        documentInfo.issued_city = scanResponse.data.issued_city;
        documentInfo.issued_department = scanResponse.data.issued_department;
        documentInfo.rh = scanResponse.data.blood_type_and_rh_factor;
        documentInfo.finger_printed = parseInt(scanResponse.data.signed_finger_print, 10);
        documentInfo.bar_code = scanResponse.data.bar_code_base64;
        documentInfo.back_document_picture = this.abreCuentasService.proccessBase64(scanResponse.data.back_document_photo);
        this.abreCuentasService.setDocumentInfo(documentInfo);
        console.warn('Datos Actualizados: ', this.abreCuentasService.getDocumentInfo());
        this.channelCommunicatorService.getImpl().sendDataToDSB(documentInfo.document_number);
        this.termsAndConditions();
        this.sendBackDocumentInfo(documentInfo);
        this.statusSendBackDocument$.subscribe(function (status) {
            if (status.error) {
                _this.navigationService.navigateToGeneralInformation(status.code);
            }
            else {
                _this.navigationService.nextStep(status.code);
            }
        });
    };
    /**
     * Función para retornar el sexo como string
     * @param sex
     */
    IdentificationService.prototype.getSexToString = function (sex) {
        return sex === 'M' ? 'M' : 'F';
    };
    /**
     * Función para evaluar el número de documento y esteblecer el valor en string
     * @param documentType
     */
    IdentificationService.prototype.getDocumentType = function (documentType) {
        var document_type;
        switch (documentType) {
            case '02':
            case '03':
                document_type = 'CC';
                break;
            case 'I3':
                document_type = 'TI';
                break;
            default:
                document_type = 'CC';
                break;
        }
        return document_type;
    };
    /**
     * Función asíncrona para enviar la información de la parte frontal del documento
     *
     * *Async Function that sends fron document info*
     *
     * @type {function}
     * @param {string} documentPhoto
     * @param {string} facePhoto
     * @returns {Promise}
     */
    IdentificationService.prototype.sendFrontDocumentInfo = function (documentPhoto, facePhoto) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService
                            .sendFrontDocumentInfo(documentPhoto, facePhoto)
                            .then(function (res) { return resolve(res); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    IdentificationService.prototype.sendFingerPrintsInfo = function (scan) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, body;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                data = scan.data;
                body = {
                    index_fingerprint: {
                        capture: this.abreCuentasService.proccessBase64(data.fingerPrints.index.capture),
                        wsq_path: data.fingerPrints.index.wsqPath,
                        minutia: data.fingerPrints.index.minutia,
                    },
                    middle_fingerprint: {
                        capture: this.abreCuentasService.proccessBase64(data.fingerPrints.middle.capture),
                        wsq_path: data.fingerPrints.middle.wsqPath,
                        minutia: data.fingerPrints.middle.minutia,
                    },
                    ring_fingerprint: {
                        capture: this.abreCuentasService.proccessBase64(data.fingerPrints.ring.capture),
                        wsq_path: data.fingerPrints.ring.wsqPath,
                        minutia: data.fingerPrints.ring.minutia,
                    },
                    pinky_fingerprint: {
                        capture: this.abreCuentasService.proccessBase64(data.fingerPrints.pinky.capture),
                        wsq_path: data.fingerPrints.pinky.wsqPath,
                        minutia: data.fingerPrints.pinky.minutia,
                    },
                    hand_capture: this.abreCuentasService.proccessBase64(data.fingerPrints.hand.capture),
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService
                            .sendFingerPrintsInfo(body)
                            .then(function (res) { return resolve(res); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    IdentificationService.prototype.getClientInformation = function (parms) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService
                            .getClientInformation(parms)
                            .then(function (res) { return resolve(res); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    IdentificationService.prototype.sendProspectOccupation = function (occupation, document) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var body, selectedAgreement, parms;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                body = {
                    occupation_id: occupation.id,
                    ciiu: occupation.ciiu,
                    document_id: document.document_number,
                };
                if (this.abreCuentasService.getproductSelected().code === '201') {
                    selectedAgreement = this.abreCuentasService.getAgreementSelected();
                    body.occupation_id = 1;
                    body.ciiu = '010';
                    body['product_type'] = 'NOMINA';
                    body['benefit_code'] = 'NODEFINIDO';
                    if (selectedAgreement.transaction_type === 'true') {
                        body['benefit_code'] = 'USAYNOPAGUES';
                    }
                }
                parms = {
                    main_activity_id: occupation.id,
                    first_name: this.abreCuentasService.getDocumentInfo().firstname,
                    first_surname: this.abreCuentasService.getDocumentInfo().primary_lastname,
                    product_type: BUSINESS_CONST.PRODUCT_TYPE_SAVINGS,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService
                            .sendProspectOccupation(body, parms)
                            .then(function (res) { return resolve(res); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Consulta por cedula el cliente
     *
     * @type {function}
     * @returns {Promise}
     */
    IdentificationService.prototype.validateIfClientExists = function (documentInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, this.requestService.sendBackDocumentInfo(documentInfo)];
                    case 1:
                        response = _a.sent();
                        if (!(response.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, JSON.parse(this.cipherService.decrypt(response.body.data.message))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: return [2 /*return*/, { notFound: true }];
                    case 4:
                        error_1 = _a.sent();
                        this.navigationService.navigateToGeneralInformation('131');
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Consulta base de datos relacionados
     *
     * @type {function}
     * @returns {Promise}
     */
    IdentificationService.prototype.validateIfIsRelated = function (documentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, error_2, bitacoraEvent;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.requestService.checkIfIsRelated(documentId)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.body];
                        }
                        return [2 /*return*/, { notFound: true }];
                    case 2:
                        error_2 = _a.sent();
                        bitacoraEvent = "employee_members_fail";
                        this.bitacoraService.saveDataInBitacora(bitacoraEvent);
                        this.navigationService.navigateToGeneralInformation('tech');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    IdentificationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function IdentificationService_Factory() { return new IdentificationService(i0.ɵɵinject(i1.HelpersService), i0.ɵɵinject(i2.RequestService), i0.ɵɵinject(i3.BioCatchService), i0.ɵɵinject(i4.NavigationService), i0.ɵɵinject(i5.AbreCuentasService), i0.ɵɵinject(i6.PortalPnImplService), i0.ɵɵinject(i7.ChannelCommunicatorService), i0.ɵɵinject(i8.TaggingService), i0.ɵɵinject(i9.BitacoraService), i0.ɵɵinject(i10.CryptoVaultService), i0.ɵɵinject(i11.LoaderService)); }, token: IdentificationService, providedIn: "root" });
    return IdentificationService;
}());
export { IdentificationService };
